import { Component, Input, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { customerInterface } from 'src/app/util/interfaces/customer';
import { impactInterface, requestClassificationInterface } from 'src/app/util/interfaces/requestClassification';
import { DefaultImpactService, searchDefaultImpactDTO } from './service/default-impact.service';
import { NotificationService } from 'src/app/services/notification/notification.service';

@Component({
	selector: 'register-default-impact',
	templateUrl: './default-impact.component.html',
	styleUrl: './default-impact.component.scss',
})
export class DefaultImpactComponent implements OnInit {
	@Input()
	labels = {
		lbl_nao_necessario_preencher_todos_campos_busca: '',
		lbl_geral_cliente: '',
		lbl_geral_pesquisar: '',
		lbl_geral_grupo: '',
		lbl_geral_salvar: '',
		lbl_salvo_com_sucesso: '',
	};

	classificationOptions = {
		isEditingClassification: true,
		disabled: false,
		selectedCustomer: null,
		lockField: [],
		hideField: ['serviceType'],
		alertField: [],
		initOn: 'solution_area',
		thisAnalystOnly: false,
		hideServiceType: [],
	};

	constructor(
		private ProfileService: ProfileService,
		private DefaultImapctService: DefaultImpactService,
		private NotificationService: NotificationService
	) {}

	isLoadingAvailableCustomer = true;
	isLoadingClassification = false;
	isSearching = false;
	isSaving = false;

	availableCustomers: customerInterface[] = [];
	availableCustomersIAC: iacOptionInterface[] = [];
	selectedCustomer: iacOptionInterface = { name: '', value: '' };
	searchClassification: requestClassificationInterface;

	availableImpacts: impactInterface[] = [];
	classificationArr: searchDefaultImpactDTO[] = [];

	ngOnInit(): void {
		this.ProfileService.getAvailableCustomers().subscribe({
			next: (customers) => {
				this.availableCustomers = customers;
				for (const customer of this.availableCustomers) {
					const newIAC: iacOptionInterface = {
						name: customer.customer,
						value: customer.id,
					};
					this.availableCustomersIAC.push(newIAC);
				}
			},
			complete: () => {
				this.selectedCustomer.value = this.ProfileService.userData().idCustomer;
				this.selectedCustomer.name = this.ProfileService.userData().customer;
				this.isLoadingAvailableCustomer = false;
			},
		});
		this.resetSearchClassification();
	}

	setSearchClassification(classificationEvent: any): void {
		classificationEvent = JSON.parse(classificationEvent);
		this.resetSearchClassification();
		this.searchClassification.solutionArea = classificationEvent.solutionArea;
		this.searchClassification.serviceType = classificationEvent.serviceType;
		this.searchClassification.scope = classificationEvent.scope;
		this.searchClassification.category = classificationEvent.category;
		this.searchClassification.topic = classificationEvent.topic;
	}

	resetSearchClassification(): void {
		this.searchClassification = {
			serviceType: [],
			scope: [],
			category: [],
			topic: [],
			solutionArea: [],
			impact: [],
			urgency: [],
			severity: [],
		};
	}

	search(): void {
		if (this.isSearching == true || this.isLoadingClassification == true) return;

		this.isSearching = true;
		forkJoin([
			this.DefaultImapctService.getAvailableImpact(this.selectedCustomer.value),
			this.DefaultImapctService.searchClassifications(this.searchClassification),
		]).subscribe({
			next: (forkRes) => {
				const availableUrgenciesRes = forkRes[0];
				const searchRes = forkRes[1];

				this.availableImpacts = availableUrgenciesRes;
				this.classificationArr = searchRes;
			},
			complete: () => {
				this.isSearching = false;
			},
		});
	}

	saveDefaultImpact() {
		if (this.isSaving == true || this.isLoadingClassification == true) return;

		this.isSaving = true;
		const saveClassification: searchDefaultImpactDTO[] = [];
		for (const classification of this.classificationArr) {
			if (classification.defaultImpact != 'N/A') saveClassification.push(classification);
		}
		this.DefaultImapctService.saveDefaultImpact(saveClassification).subscribe({
			next: () => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
			},
			complete: () => {
				this.isSaving = false;
			},
		});
	}
}
